export function checkoutPath(config, productId) {
  if (!productId) throw new Error('Missing product');
  if (config.has_subscription) return '/billing';
  if (config.checkout_available === false) throw new Error('Billing is unavailable');
  if (config.provider === 'stripe') {
    if (!config.stripe_enabled || !config.stripe_products?.includes(productId)) {
      throw new Error('This plan is not available right now');
    }
    return `/checkout/${encodeURIComponent(productId)}`;
  }
  if (config.provider !== 'fastspring') throw new Error('Invalid billing provider');
  return `/payment/${encodeURIComponent(productId)}`;
}

export async function checkoutDestination(config, productId, createCheckout) {
  const path = checkoutPath(config, productId);
  if (!path.startsWith('/checkout/')) return path;
  const url = await createCheckout(productId);
  if (!isStripeHostedUrl(url)) throw new Error('Invalid checkout URL');
  return url;
}

export function canUpgradePlan(config, productId) {
  return !!(config?.stripe_enabled && config.has_subscription && config.has_paid_access && config.subscription_provider === 'stripe' && config.subscription_status === 'active' && !config.auto_renew_disabled && config.current_product_id !== productId && config.stripe_upgrade_products?.includes(productId));
}

// Old account status confirms access, but cannot authorize a new payment.
// Purchased credits and a generic purchase flag never prove a subscription.
export function legacyAccountBillingConfig(account, catalog = []) {
  if (!account || typeof account.id !== 'string' || !account.id || ![0, 1, 2].includes(account.type)) {
    throw new Error('Account status unavailable');
  }
  const paid = account.type === 1;
  const productId = typeof account.productId === 'string' ? account.productId : '';
  const webProduct = productId && catalog.some(plan => plan.product_id === productId && plan.group_id !== 'free');
  const knownProviders = ['fastspring', 'stripe', 'ios', 'android'];
  const provider = knownProviders.includes(account.subscription_provider) ? account.subscription_provider : webProduct ? 'fastspring' : 'legacy_unknown';
  const number = value => Number.isFinite(Number(value)) ? Number(value) : 0;
  return {
    provider: knownProviders.includes(provider) ? provider : 'fastspring',
    stripe_enabled: false, stripe_products: [], checkout_available: false,
    has_subscription: paid, has_paid_access: paid, current_product_id: paid ? productId : '',
    subscription_provider: provider, sub_ended: number(account.sub_ended),
    auto_renew_disabled: account.disable_auto === 1, intro_eligible: account.has_bought === 0,
    points_balance: number(account.free_points) + number(account.vip_points) + number(account.buy_points),
    stripe_portal_available: false, stripe_cancellation_available: false,
    legacy_subscription_present: paid && provider === 'fastspring',
  };
}

export function billingResponseData(response) {
  if (!response || response.code !== 200 || !response.data || typeof response.data !== 'object') {
    const error = new Error('Billing request failed');
    error.response = { status: Number(response?.code) || 502 };
    throw error;
  }
  return response.data;
}

export function isStripeHostedUrl(value) {
  try {
    const url = new URL(value);
    return url.protocol === 'https:' && ['checkout.stripe.com', 'billing.stripe.com'].includes(url.hostname);
  } catch { return false; }
}
